import { GetLocalStorage } from '../components/commonClass/Session';
import { decrpt, decrptdata, encrypt, encryptedString } from '../components/commonClass/enc_dec/enc_dec';
const Url = process.env.REACT_APP_API_URL


const encryptedQueryStringData = (endpoint) => {
    let queryStringData = endpoint?.split('?')[1]?.split('&')?.map((obj) => {
        let queryString = obj?.split('=')
        queryString[1] = encodeURIComponent(encrypt(isNaN(queryString[1]) ? queryString[1] : Number(queryString[1])))
        return [queryString[0], queryString[1]]?.join('=')
    })
    return endpoint?.split('?')?.length > 1 ? [endpoint?.split('?')[0], queryStringData?.join('&')]?.join('?') : endpoint
}

export async function verifytoken() {
    let status = false;
    try {
        let token = GetLocalStorage();
        const response = await fetch(Url + '/auth/v1/tokenVerify', {
            headers: { 'Authorization': `Bearer ${token.token}` }
        })
        const data = await response.json()
        status = true;
        return status;
    }
    catch (error) {
        status = false;
        return status;
    }
}


export async function getAllData(endpoint) {
    endpoint = encryptedQueryStringData(endpoint);
    try {
        let token = GetLocalStorage();
        const url = Url + endpoint;
        const response = await fetch(url, {
            headers: { 'Access-Control-Allow-Origin': '*', 'Authorization': `Bearer ${token.token}` }
        });
        const TAGData = await response.json();
        try {
            TAGData.data = TAGData?.data ? decrpt(TAGData?.data) : null
        } catch (error) {
            TAGData.data = TAGData?.data ? decrptdata(TAGData?.data) : null
        }
        return TAGData;
    }
    catch (error) {
        return [];
    }
}

export async function getDataByPara(dataparam, getparam) {
    const urlparam = Url + dataparam;
    try {
        const getresponse = await fetch(urlparam,
            {
                method: 'POST', // or 'PUT'
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(encryptedString(encrypt(getparam))),

            });
        const getTAGData = await getresponse.json();
        try {
            getTAGData.data = getTAGData?.data ? decrpt(getTAGData?.data) : null
        } catch (error) {
            getTAGData.data = getTAGData?.data ? decrptdata(getTAGData?.data) : null
        }
        return getTAGData;
    }
    catch (error) {
        return [];
    }
}

export async function postUsersData(postsurl, postdata) {
    try {
        let token = GetLocalStorage();
        const posturl = Url + postsurl;
        const postresponse = await fetch(posturl,
            {
                method: 'POST', // or 'PUT'
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(encryptedString(encrypt(postdata))),
            });
        const PostTAGData = await postresponse.json();
        try {
            PostTAGData.data = PostTAGData?.data ? decrpt(PostTAGData?.data) : null
        } catch (error) {
            PostTAGData.data = PostTAGData?.data ? decrptdata(PostTAGData?.data) : null
        }
        return PostTAGData;
    }
    catch (error) {
        return [];
    }
}
export async function patchUsersData(patchsurls, patchdata) {
    try {
        let token = GetLocalStorage();
        const patchsurl = Url + patchsurls;
        const patchresponse = await fetch(patchsurl,
            {
                method: 'PATCH', // or 'PUT'
                headers: {
                    'Authorization': `Bearer ${token.token}`,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(encryptedString(encrypt(patchdata))),
            });
        const patchTAGData = await patchresponse.json();
        try {
            patchTAGData.data = patchTAGData?.data ? decrpt(patchTAGData?.data) : null
        } catch (error) {
            patchTAGData.data = patchTAGData?.data ? decrptdata(patchTAGData?.data) : null
        }
        return patchTAGData;
    }
    catch (error) {
        return [];
    }
}
export async function deleteUserData(endpoint) {
    endpoint = encryptedQueryStringData(endpoint);
    try {
        let token = GetLocalStorage();
        const url = Url + endpoint;
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token.token}`,
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }
        });
        const TAGData = await response.json();
        try {
            TAGData.data = TAGData?.data ? decrpt(TAGData?.data) : null
        } catch (error) {
            TAGData.data = TAGData?.data ? decrptdata(TAGData?.data) : null
        }
        return TAGData;
    }
    catch (error) {
        return [];
    }
}